// Stamp UTM params on every outbound storefront / streaming link, so Kabir
// can attribute conversion back to the on-site placement that drove it.
//
//   addUtm("https://www.amazon.in/dp/B0…", { campaign: "books-hanuman" })
//
// Existing query params on the URL are preserved.

const SOURCE = "dharmaweave_site";
const MEDIUM = "web";

export function addUtm(rawUrl, { campaign, content } = {}) {
  if (!rawUrl) return rawUrl;
  try {
    const u = new URL(rawUrl);
    u.searchParams.set("utm_source", SOURCE);
    u.searchParams.set("utm_medium", MEDIUM);
    if (campaign) u.searchParams.set("utm_campaign", campaign);
    if (content) u.searchParams.set("utm_content", content);
    return u.toString();
  } catch {
    return rawUrl;
  }
}
